<div class="page-container">
    <div class="change-password-card">

        <!-- Header -->
        <div class="card-header">
            <div class="brand-section">
                <img src="/vat-logo.png" alt="VAT Logo" class="vat-logo">
                <h2 class="brand-title">VAT E-Service</h2>
            </div>

            <div class="lock-icon-wrapper">
                <div class="lock-icon-circle">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                </div>
            </div>

            <h1 class="card-title">ตั้งรหัสผ่านใหม่</h1>
            <p class="card-subtitle">
                ระบบตรวจพบว่าบัญชีของท่านใช้รหัสผ่านชั่วคราว<br>
                กรุณาเปลี่ยนรหัสผ่านเพื่อความปลอดภัยของบัญชี
            </p>
        </div>

        <!-- Info Banner -->
        <div class="info-banner">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>รหัสผ่านชั่วคราวถูกส่งไปยังอีเมลที่ลงทะเบียนไว้</span>
        </div>

        <!-- Success Message -->
        <div class="success-message" *ngIf="successMessage" role="alert">
            <div class="success-content">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span>{{ successMessage }}</span>
            </div>
        </div>

        <!-- Error Message -->
        <div class="error-message" *ngIf="errorMessage" role="alert">
            <div class="error-content">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <span>{{ errorMessage }}</span>
            </div>
            <button type="button" class="clear-error-btn" (click)="errorMessage = ''" aria-label="ปิดข้อความแจ้งเตือน">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <!-- Form -->
        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="card-form" autocomplete="off">

            <!-- Temp Password Field -->
            <div class="form-group">
                <label class="form-label" for="tempPassword">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                    </svg>
                    รหัสผ่านชั่วคราว (จากอีเมล)
                    <span class="required-star">*</span>
                </label>
                <div class="input-wrapper">
                    <input id="tempPassword" [type]="showTempPassword ? 'text' : 'password'"
                        formControlName="tempPassword" class="form-input"
                        [class.error]="tempPassword?.invalid && tempPassword?.touched"
                        placeholder="กรอกรหัสผ่านที่ได้รับจากอีเมล" autocomplete="off">
                    <button type="button" class="toggle-password-btn" (click)="toggleVisibility('temp')"
                        [attr.aria-label]="showTempPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
                        <svg *ngIf="!showTempPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        <svg *ngIf="showTempPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                    </button>
                </div>
                <div class="field-error" *ngIf="tempPassword?.invalid && tempPassword?.touched">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                    <span *ngIf="tempPassword?.errors?.['required']">กรุณากรอกรหัสผ่านชั่วคราว</span>
                    <span *ngIf="tempPassword?.errors?.['minlength']">รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร</span>
                </div>
            </div>

            <!-- Divider -->
            <div class="divider">
                <div class="divider-line"></div>
                <span class="divider-text">ตั้งรหัสผ่านใหม่</span>
                <div class="divider-line"></div>
            </div>

            <!-- New Password Field -->
            <div class="form-group">
                <label class="form-label" for="newPassword">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <circle cx="12" cy="16" r="1"></circle>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    รหัสผ่านใหม่
                    <span class="required-star">*</span>
                </label>
                <div class="input-wrapper">
                    <input id="newPassword" [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                        class="form-input" [class.error]="newPassword?.invalid && newPassword?.touched"
                        placeholder="กรอกรหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)" autocomplete="new-password">
                    <button type="button" class="toggle-password-btn" (click)="toggleVisibility('new')"
                        [attr.aria-label]="showNewPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
                        <svg *ngIf="!showNewPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        <svg *ngIf="showNewPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                    </button>
                </div>

                <!-- Password Strength Bar -->
                <div class="password-strength-wrapper" *ngIf="newPassword?.value">
                    <div class="strength-bar-track">
                        <div class="strength-bar-fill" [class]="passwordStrength" [style.width]="strengthBarWidth">
                        </div>
                    </div>
                    <span class="strength-label" [class]="passwordStrength">
                        <span *ngIf="passwordStrength === 'weak'">ความปลอดภัยต่ำ</span>
                        <span *ngIf="passwordStrength === 'medium'">ความปลอดภัยปานกลาง</span>
                        <span *ngIf="passwordStrength === 'strong'">ความปลอดภัยสูง</span>
                    </span>
                </div>

                <div class="field-error" *ngIf="newPassword?.invalid && newPassword?.touched">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                    <span *ngIf="newPassword?.errors?.['required']">กรุณากรอกรหัสผ่านใหม่</span>
                    <span *ngIf="newPassword?.errors?.['minlength']">รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร</span>
                    <span *ngIf="newPassword?.errors?.['pattern']">รหัสผ่านต้องมีตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่
                        และตัวเลข</span>
                </div>

                <!-- Password Requirements -->
                <div class="password-requirements">
                    <p class="requirements-title">รหัสผ่านต้องประกอบด้วย:</p>
                    <ul>
                        <li [class.met]="hasMinLength">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="3">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            อย่างน้อย 8 ตัวอักษร
                        </li>
                        <li [class.met]="hasLowercase">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="3">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            ตัวอักษรพิมพ์เล็ก (a-z)
                        </li>
                        <li [class.met]="hasUppercase">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="3">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            ตัวอักษรพิมพ์ใหญ่ (A-Z)
                        </li>
                        <li [class.met]="hasNumber">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="3">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            ตัวเลข (0-9)
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Confirm Password Field -->
            <div class="form-group">
                <label class="form-label" for="confirmPassword">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    ยืนยันรหัสผ่านใหม่
                    <span class="required-star">*</span>
                </label>
                <div class="input-wrapper">
                    <input id="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
                        formControlName="confirmPassword" class="form-input"
                        [class.error]="confirmPassword?.invalid && confirmPassword?.touched"
                        [class.success]="confirmPassword?.valid && confirmPassword?.touched && confirmPassword?.value"
                        placeholder="กรอกรหัสผ่านใหม่อีกครั้ง" autocomplete="new-password">
                    <button type="button" class="toggle-password-btn" (click)="toggleVisibility('confirm')"
                        [attr.aria-label]="showConfirmPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
                        <svg *ngIf="!showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        <svg *ngIf="showConfirmPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                    </button>
                </div>
                <div class="field-error" *ngIf="confirmPassword?.invalid && confirmPassword?.touched">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                    <span *ngIf="confirmPassword?.errors?.['required']">กรุณายืนยันรหัสผ่าน</span>
                    <span *ngIf="confirmPassword?.errors?.['passwordMismatch']">รหัสผ่านไม่ตรงกัน
                        กรุณาตรวจสอบอีกครั้ง</span>
                </div>
                <div class="field-success"
                    *ngIf="confirmPassword?.valid && confirmPassword?.touched && confirmPassword?.value">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <span>รหัสผ่านตรงกัน</span>
                </div>
            </div>

            <!-- Submit Button -->
            <button id="submit-change-password" type="submit" class="submit-btn"
                [disabled]="isLoading || changePasswordForm.invalid" [class.loading]="isLoading">
                <span *ngIf="!isLoading">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    </svg>
                    ยืนยันการเปลี่ยนรหัสผ่าน
                </span>
                <span *ngIf="isLoading" class="loading-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        class="spin">
                        <path d="M21 12a9 9 0 11-6.219-8.56" />
                    </svg>
                    กำลังบันทึก...
                </span>
            </button>

        </form>

        <!-- Footer -->
        <div class="card-footer">
            <p>&copy; 2026 VAT Management System. All rights reserved.</p>
        </div>
    </div>
</div>